import { useTranslations } from 'next-intl';

import type { IconRef, ItemType } from '@/config/itemTypes';
import dugoutMenuIcon from '@/utils/dugoutMenuIcon';

interface ItemsProps {
  shirtTypes: ItemType[];
  goalTypes: ItemType[];
  itemTypes: ItemType[];
  coneTypes: ItemType[];
  iconType: string;
  isMobile?: boolean;
  drawingType?: string | false;
  // Passed rather than read from ToolContext: Items is purely presentational and its tests/stories
  // render it without a provider.
  isDugoutTheme?: boolean;
}

const Items = ({
  shirtTypes,
  goalTypes,
  itemTypes,
  coneTypes,
  iconType,
  isMobile,
  drawingType,
  isDugoutTheme = false,
}: ItemsProps) => {
  const t = useTranslations();

  // Dugout shows per-team recoloured menu thumbnails (matching its own tool); every other theme shows
  // the raw defaultIcon. This only swaps the visual <img> src — the drag/drop data-* attributes stay
  // raw (canvas placement recolours at runtime), so non-dugout menu output is byte-identical.
  const iconSrc = (item: ItemType) =>
    isDugoutTheme ? dugoutMenuIcon(item, iconType) : item.defaultIcon.src;

  const filteredGoalTypes = drawingType
    ? goalTypes.filter((item) =>
        item.fieldTypes?.includes(drawingType) ? item : null,
      )
    : goalTypes;
  return (
    <section id="Items-container" className="Section Items">
      <h2 className="Section-heading">{t('DRWNG__MENU_PLAYERS')}</h2>
      <div className="Section-inner">
        {shirtTypes.map((item, index) => {
          return (
            <div className={isMobile ? 'Item-container' : ''} key={index}>
              <div
                className={`Draggable-itemWrap Asset--${item.variation}`}
                // className={`Draggable-itemWrap Asset--shirt${isDragging ? ' Controls-img--base' : ''}`}
                draggable={isMobile ? 'false' : 'true'}
                data-name={item.name}
                data-label={t(`DRWNG__ITEM_${item.variation}`)}
                data-variation={item.variation}
                data-color={item.color}
                data-width={item.width}
                data-height={item.height}
                data-default-icon={item.defaultIcon.src}
                data-src={
                  (item[iconType as keyof ItemType] as IconRef | undefined)?.src
                }
                data-font-color={item.fontColor}
              >
                <img src={iconSrc(item)} alt="" />
              </div>
              {isMobile && <span> {t(`DRWNG__ITEM_${item.variation}`)}</span>}
            </div>
          );
        })}
        {itemTypes.map((item, index) => (
          <div className={isMobile ? 'Item-container' : ''} key={index}>
            <div
              key={index}
              className={`Draggable-itemWrap Asset--${item.variation}`}
              draggable={isMobile ? 'false' : 'true'}
              data-name={t(`DRWNG__ITEM_${item.variation}`)}
              data-label={t(`DRWNG__ITEM_${item.variation}`)}
              data-variation={item.variation}
              data-width={item.width}
              data-height={item.height}
              data-src={
                (item[iconType as keyof ItemType] as IconRef | undefined)?.src
              }
            >
              <img src={iconSrc(item)} alt="" />
            </div>
            {isMobile && <span> {t(`DRWNG__ITEM_${item.variation}`)}</span>}
          </div>
        ))}
        {coneTypes.map((item, index) => (
          <div className={isMobile ? 'Item-container' : ''} key={index}>
            <div
              key={index}
              className={`Draggable-itemWrap Asset--${item.variation}`}
              draggable={isMobile ? 'false' : 'true'}
              data-name={item.name}
              data-label={t(`DRWNG__ITEM_${item.variation}`)}
              data-variation={item.variation}
              data-color={item.color}
              data-width={item.width}
              data-height={item.height}
              data-src={
                (item[iconType as keyof ItemType] as IconRef | undefined)?.src
              }
            >
              <img src={iconSrc(item)} alt="" />
            </div>
            {isMobile && <span> {t(`DRWNG__ITEM_${item.variation}`)}</span>}
          </div>
        ))}
        {filteredGoalTypes?.map((item, index) => (
          <div className={isMobile ? 'Item-container' : ''} key={index}>
            <div
              className={`Draggable-itemWrap Asset--${item.variation}`}
              draggable={isMobile ? 'false' : 'true'}
              data-name={item.name}
              data-label={t(`DRWNG__ITEM_${item.variation}`)}
              data-variation={item.variation}
              data-width={item.width}
              data-height={item.height}
              data-src={
                (item[iconType as keyof ItemType] as IconRef | undefined)?.src
              }
            >
              <img src={iconSrc(item)} alt="" />
            </div>
            {isMobile && <span> {t(`DRWNG__ITEM_${item.variation}`)}</span>}
          </div>
        ))}
      </div>
    </section>
  );
};

export default Items;
